import { NAV_MENU_TYPE, type HistoryRowData } from '@eureka/shared/nav-bar/src/types';
import { combineHash, combineUrl } from '@eureka/utils/url';

const allowedTypes = [
    NAV_MENU_TYPE.LS_DOCUMENT_QA,
    NAV_MENU_TYPE.LS_SAAS_CHAT,
    NAV_MENU_TYPE.LS_MARKUSH_PATENT_DRAFT,
    NAV_MENU_TYPE.AI_GENERATE
];

export function resolveEurekaLsLink(link: string) {
    if (link.startsWith('http://') || link.startsWith('https://')) return link;
    return combineHash(combineUrl(import.meta.env.VITE_EUREKA_URI, 'ls'), link);
}

export function resolveHistoryLink(item: HistoryRowData) {
    const link = item.link;
    if (link.startsWith('http://') || link.startsWith('https://')) return link;
    if (allowedTypes.includes(item.source)) {
        return combineHash(combineUrl(import.meta.env.VITE_EUREKA_URI, 'ls'), link);
    }
    return combineUrl(import.meta.env.VITE_EUREKA_URI, link);
}

export function resolveEurekaLink(link: string) {
    if (link.startsWith('http://') || link.startsWith('https://')) return link;
    return combineUrl(import.meta.env.VITE_EUREKA_URI, link);
}
